import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { push } from "react-router-redux"
import { Route, Link, Switch } from "react-router-dom"
import {
  Slider,
  Select,
  Button as AButton,
  Col,
  Row,
  Icon as AIcon,
  Radio,
  Tooltip,
  Dropdown,
  Menu,
  Input,
  Modal
} from "antd"

import {
  MoreIcon,
  CheckedIcon,
  InvoiceIcon,
  VisaLogo,
  MastercardLogo,
  AmericanExpressLogo,
  DiscoverLogo,
  DinersClubLogo,
  JCBLogo
} from "../core/icons"
import Line from "../core/Line"
// import CreateSubscriptionSuccessModal from "./CreateSubscriptionSuccessModal"

import Card, { TitleCard, CardHeader } from "../core/Card"
import {
  getPlans,
  getInvoices,
  selectPlanFromUrl,
  handleCancelReactivateClick
} from "./actions"
import onMount from "../core/onMount"
import twix from "twix"
import moment from "moment"
import numeral from "numeral"

import ConnectedPlan from "./ConnectedPlan"

const Plans = props => (
  <Card style={{ minHeight: 340 }} showLoadingIcon={props.isFetchingPlans}>
    <h1 style={{ margin: 0 }}>Select Pricing Plan</h1>
    <div
      style={{
        display: "flex",
        justifyContent: "space-around",
        flexWrap: "wrap"
      }}
    >
      {props.plans.map(plan => <ConnectedPlan plan={plan} />)}
    </div>
  </Card>
)

const mapStateToProps = (state, ownProps) => {
  const { plans, invoices } = state.models
  return {
    plans,
    isFetchingPlans: state.subs.isFetchingPlans
  }
}

export default connect(mapStateToProps)(
  onMount(({ dispatch }) => {
    dispatch(getPlans())
    dispatch(selectPlanFromUrl())
  })(Plans)
)



// WEBPACK FOOTER //
// ./src/subscriptions/Plans.js